<script>
export default {
    props: {
        layout: {
            type: Object,
            default: function() {
                return {
                    label: 6,
                    wrapper: 16
                };
            }
        },
        session: {
            type: String,
            default: ''
        },
        attendant: {
            type: String,
            default: null
        },
        reupload: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            formLayout: 'horizontal',
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            item: {},
            fileList: []
        };
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault(e);

            this.form.validateFields((err, formData) => {
                if (!err) {
                    this.processing = true;

                    let promise;

                    var data = new FormData();

                    for (var k in formData) {
                        if (formData.hasOwnProperty(k)) {
                            data.append(k, formData[k]);
                        }
                    }


                    if(this.attendant != null)
                        data.append("attendant", this.attendant);

                    data.append("attachment", this.fileList[0]);

                    if(!this.reupload){
                        promise = this.$http.post(
                            this.routeUri("api.classical-resumes.upload", {session: this.session}),
                            data
                        );
                    }else{
                        promise = this.$http.post(
                            this.routeUri("api.classical-resumes.reupload", {resume: this.session}),
                            data
                        );
                    }

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                        .finally(() => (this.processing = false));
                }
            });
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => this.$emit("handleClose", true), 1000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }

        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
            this.data = [];
        },
        beforeUpload(file) {
            this.fileList = [...this.fileList, file];
            return false;
        },
        handleChange(info) {
            let fileList = [...info.fileList];

            if (fileList.length > 1) {
                fileList = [info.file];

                this.fileList = fileList;
            }
        },
        handleClose() {
            this.$emit("handleClose", false);
        }
    },
};
</script>

<template>
    <a-card type="inner" size="small">
        <a-skeleton :loading="preload" active>
            <a-form :form="form" :layout="formLayout" @submit="handleSubmit">
                <a-divider dashed orientation="left"
                    >Upload video</a-divider
                >
                <a-form-item label="Video Resume">
                    <a-upload
                        :file-list="fileList"
                        :remove="handleRemove"
                        :before-upload="beforeUpload"
                        @change="handleChange"
                    >
                        <a-button>
                            <a-icon type="upload" /> Select File
                        </a-button>
                    </a-upload>
                </a-form-item>
                <a-form-item>
                    <a-row type="flex" justify="center" align="top">
                        <a-col>
                            <a-space>
                                <a-button
                                    type="primary"
                                    html-type="submit"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Submit</a-button>
                                <a-button
                                    @click="handleClose"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Tutup</a-button>
                            </a-space>
                        </a-col>
                    </a-row>
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-card>
</template>
